import { useAuthStore } from '@/stores/authStore';
import { useOrganization } from '@/hooks/useOrganization';
import { useSavedAccountsStore } from '@/stores/savedAccounts/savedAccountsStore';
import type { SavedAccount } from '@/stores/savedAccounts/savedAccounts.types';

export type { SavedAccount };

export interface UseSavedAccountsReturn {
  accounts: SavedAccount[];
  removeAccount: (slug: string, email: string) => void;
  currentAccount: SavedAccount | null;
}

export function useSavedAccounts(): UseSavedAccountsReturn {
  const accounts = useSavedAccountsStore((s) => s.accounts);
  const removeAccount = useSavedAccountsStore((s) => s.removeAccount);
  const user = useAuthStore((s) => s.user);
  const { currentOrganization } = useOrganization();

  const currentAccount =
    user?.email && currentOrganization?.slug
      ? accounts.find(
          (a) =>
            a.email.toLowerCase() === user.email.toLowerCase() &&
            a.slug.toLowerCase() === currentOrganization.slug.toLowerCase(),
        ) ?? null
      : null;
  return {
    accounts,
    removeAccount,
    currentAccount,
  };
}
